import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import api from '../../../../api';
import MenuLateral from '../../../../components/MenuLateral';
import { formatadorNumeroCelular, formatarCpfCnpj } from '../../../../utils/Validadores';

export default function Fornecedores() {
    const [fornecedores, setFornecedores] = useState([]);
    const [usuario_id, setIdUsuario] = useState();
    const [error, setError] = useState(null);
    const [texto, setTexto] = useState('');
    const [pesquisa, setPesquisa] = useState('');
    const navigate = useNavigate();
    const [mensagemErro, setMensagemErro] = useState('');
    const [loading, setLoading] = useState(true);

    const [modalExcluirAberto, setModalExcluirAberto] = useState(false);
    const [modalNaoPodeExcluirAberto, setModalNaoPodeExcluirAberto] = useState(false);
    const [idFornecedorParaExcluir, setIdFornecedorParaExcluir] = useState(null);
    const caixaDeDialogoExcluir = useRef(null);
    const caixaDeDialogoNaoPodeExcluir = useRef(null);

    useEffect(() => {
        caixaDeDialogoExcluir.current = document.getElementById('CaixaDeDialogoExcluir');
        caixaDeDialogoNaoPodeExcluir.current = document.getElementById('CaixaDeDialogoNaoPodeExcluir');
    }, []);

    const abrirModalExcluir = (id_fornecedor) => {
        setIdFornecedorParaExcluir(id_fornecedor);
        if (caixaDeDialogoExcluir.current) {
            caixaDeDialogoExcluir.current.showModal();
        }
    };

    const abrirModalExcluirError = () => {
        if (caixaDeDialogoNaoPodeExcluir.current) {
            caixaDeDialogoNaoPodeExcluir.current.showModal();
        }
    };

    const fecharModalExcluir = () => {
        if (caixaDeDialogoExcluir.current) {
            caixaDeDialogoExcluir.current.close();
        }
        setIdFornecedorParaExcluir(null);
    };

    const fecharModalNaoPodeExcluir = () => {
        if (caixaDeDialogoNaoPodeExcluir.current) {
            caixaDeDialogoNaoPodeExcluir.current.close();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    const confirmarExcluirFornecedor = async () => {
        try {
            console.log('Excluindo fornecedor com ID:', idFornecedorParaExcluir);
            const response = await api.delete(`/fornecedores/${idFornecedorParaExcluir}`, {
                data: { usuario_id }
            });

            if (response.data.success) {
                setFornecedores(fornecedores.filter(fornecedor => fornecedor.id !== idFornecedorParaExcluir));
                fecharModalExcluir();
            } else {
                setMensagemErro(response.data.message);
                abrirModalExcluirError();
            }
        } catch (error) {
            console.error('Erro ao excluir fornecedor:', error);
            setMensagemErro(error.response?.data?.message || 'Erro ao excluir fornecedor.');
            abrirModalExcluirError();
            fecharModalExcluir();
        }
    };


    const verificarFornecedorComProdutos = async (id_fornecedor) => {
        try {
            const response = await api.get(`/fornecedores/${id_fornecedor}/verificar-produtos`);
            if (response.data.temProdutos) {
                setModalNaoPodeExcluirAberto(true);
            } else {
                abrirModalExcluir(id_fornecedor);
            }
        } catch (error) {
            console.error('Erro ao verificar fornecedor:', error);
            setMensagemErro('Erro ao verificar fornecedor');
        }
    };


    const handlePesquisaChange = (e) => {
        setPesquisa(e.target.value);
    };

    const fornecedoresFiltrados = fornecedores.filter((fornecedor) => {
        return fornecedor.nome.toLowerCase().includes(pesquisa.toLowerCase());
    });

    const cadastroFornecedor = () => {
        navigate('/menu/fornecedores/cadastrofornecedor');
    };

    const handleEdit = (id) => {
        console.log(`Editar fornecedor com ID: ${id}`);
        navigate('/menu/fornecedores/editarfornecedor', { state: { id } });
    };

    const handleView = (id) => {
        console.log(`Visualizar fornecedor com ID: ${id}`);
        navigate('/menu/fornecedores/visualizarfornecedor', { state: { id } });
    };

    useEffect(() => {
        const fetchFornecedores = async () => {
            setLoading(true);
            try {
                const response = await api.get('/listarfornecedores');
                setFornecedores(response.data.fornecedores || []);
            } catch (error) {
                setError('Erro ao carregar fornecedores');
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchFornecedores();
    }, []);

    return (
        <section className='container-principal-fornecedores'>
            <dialog id="CaixaDeDialogoExcluir" className={modalExcluirAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse fornecedor?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirFornecedor}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModalExcluir}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaDeDialogoNaoPodeExcluir" className={modalNaoPodeExcluirAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Este fornecedor não pode ser excluído porque ele possui produtos vinculados.</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={fecharModalNaoPodeExcluir}>
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-fornecedores'>
                    <div className='titulo-fornecedores'><h1>Fornecedores</h1></div>
                    <div className='barraDePesquisa-e-criarFornecedores-container'>
                        <div className='barraDePesquisa-Fornecedores'>
                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z" stroke="#000" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <input
                                type='text'
                                placeholder='Pesquise o fornecedor pelo: Nome'
                                value={pesquisa}
                                onChange={handlePesquisaChange}
                            />
                        </div>
                        <button className='bnt-cadastrarFornecedores' onClick={cadastroFornecedor}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 4.16667V15.8333M4.16667 10H15.8333" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Cadastrar Fornecedor</button>
                    </div>
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando fornecedores...</h2>
                        </div>
                    ) : (
                    <div className='tabela-fornecedor'>
                        {fornecedoresFiltrados.length === 0 ? (
                            <p>Nenhum fornecedor encontrado =&#40;</p>
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CNPJ/CPF</th>
                                        <th>Telefone</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fornecedoresFiltrados.map((fornecedor) => (
                                        <tr className='conteudo' key={fornecedor.id}>
                                            <td className='primeiro'>{fornecedor.nome}</td>
                                            <td>{formatarCpfCnpj(fornecedor.cpf_cnpj)}</td>
                                            <td>{formatadorNumeroCelular(fornecedor.telefone)}</td>
                                            <td className="final">
                                                <div className='bnts-fornecedores'>
                                                    <button className='bnt-visualizar' onClick={() => handleView(fornecedor.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z" stroke-width="0.3" /></svg></button>
                                                    <button className='bnt-editar' onClick={() => handleEdit(fornecedor.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                                                    <button className='bnt-excluir' onClick={() => abrirModalExcluir(fornecedor.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /> </svg></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                    )}
                </section>
            </main>

            <Rodape />

        </section>
    );
}
